import SVG from 'react-inlinesvg';
import styled from 'styled-components';
import { ty } from '@client/styles/typography';

export const TenantLogoImage = styled.img`
  height: 64px;
  width: 64px;
  border-radius: 50%;
  border: 0.5px solid var(--border-primary);
  outline: 2px solid var(--surface-primary);
  position: relative;
`;

export const Dots = styled(SVG)`
  margin: 0px 6px;
  /* Not border-muted: under .dark it equals the surface-secondary box behind
     the logos, so the dots disappear. */
  color: var(--border-primary);
`;

export const TenantLetterContainer = styled.div`
  background-color: var(--surface-tertiary);

  border-radius: 50%;
  border: 0.5px solid var(--border-primary);
  height: 64px;
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // this padding is necessary to balance out the right padding on the SVG containing the utility icon
  padding-left: 4.8px;
  border: 1px solid var(--border-primary);
  border-radius: 100%;
  height: 64px;
  width: 64px;
`;

export const UtilityIcon = styled(SVG)`
  display: inline-block;
  flex-shrink: 0;
  height: 32px;
  width: 32px;
  color: var(--foreground-primary);
`;
export const ArcadiaLogoContainer = styled.div`
  display: flex;
  position: relative;
  border: 1px solid var(--border-primary);
  border-radius: 100%;
  height: 48px;
  width: 48px;
`;
export const ArcadiaLogo = styled(SVG)`
  alt: 'Developer Platform Logo';
  margin: auto;
  height: 40px;
  width: 40px;
`;
export const TenantLetter = styled.span.attrs({
  className: ty('tenantLetter'),
})``;

export const LogosRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
